import axios from 'axios';

const BASE_URL = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

// Create a dedicated axios instance for API calls
const api = axios.create({
  baseURL: BASE_URL,
});

// Initialize auth header from localStorage if present
const existingToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
if (existingToken) {
  api.defaults.headers.common['Authorization'] = `Bearer ${existingToken}`;
}

// Always attach latest token from localStorage for every request
api.interceptors.request.use((config) => {
  try {
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    } else if (config.headers && config.headers['Authorization']) {
      delete config.headers['Authorization'];
    }
  } catch (_) {
    // no-op
  }
  return config;
});

export default api;


// Want to Try API helpers
export const wantToTryAPI = {
  /**
   * Get the current user's Want to Try list with paginated sandwiches
   */
  async getList({ limit = 50, offset = 0, sortBy = 'recent', tag } = {}) {
    const params = {
      limit,
      offset,
      sort_by: sortBy
    };

    if (tag) {
      params.category = tag;
    }

    const response = await api.get('/lists/me/want-to-try', { params });
    return response.data;
  },

  /**
   * Get another user's Want to Try list with paginated sandwiches
   * Returns their public WichList. Will throw 403 if not public.
   */
  async getListForUser(userId, { limit = 50, offset = 0, sortBy = 'recent', tag } = {}) {
    const params = {
      limit,
      offset,
      sort_by: sortBy
    };

    if (tag) {
      params.category = tag;
    }

    const response = await api.get(`/lists/user/${userId}/want-to-try`, { params });
    return response.data;
  },

  /**
   * Fetch lightweight Want to Try metadata (counts, timestamps)
   */
  async getMeta() {
    const response = await api.get('/lists/me/want-to-try/meta');
    return response.data;
  },

  /**
   * Toggle a sandwich in the Want to Try list
   * @param {string} sandwichId - Sandwich ID
   * @param {boolean} shouldAdd - True to add, false to remove
   */
  async toggle(sandwichId, shouldAdd, options = {}) {
    if (shouldAdd) {
      const payload = options.sourceReviewId ? { source_review_id: options.sourceReviewId } : undefined;
      return await api.post(`/lists/want-to-try/${sandwichId}`, payload);
    } else {
      return await api.delete(`/lists/want-to-try/${sandwichId}`);
    }
  },

  /**
   * Batch check which sandwiches are in the Want to Try list
   * @param {string[]} sandwichIds - Array of sandwich IDs
   * @returns {Promise<Object>} Map of sandwich_id -> boolean
   */
  async checkContains(sandwichIds) {
    const response = await api.post('/lists/want-to-try/contains', {
      sandwich_ids: sandwichIds
    });
    return response.data.contains || {};
  }
};


